import { render } from "./OldAchievementIndex.vue?vue&type=template&id=5fb0ea10"
import script from "./OldAchievementIndex.vue?vue&type=script&lang=js"
export * from "./OldAchievementIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__